import { Button } from "@animech/ui";
import { FunctionComponent, useContext } from "react";
import { useUiData } from "src/ui/data";
import { ApiDataContext, useSaveAndPdf } from "src/api";

export const PrintButton: FunctionComponent = () => {
	const { localizer } = useUiData();
	const { isLoading } = useContext(ApiDataContext);
	const saveAndOpenPDf = useSaveAndPdf();

	return (
		<Button
			appearance="ghost"
			onClick={() => saveAndOpenPDf()}
			busy={isLoading}
		>
			{localizer.localizeTerm("cartSummaryExportPDF")}
		</Button>
	);
};
